import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FolderIcon from '@mui/icons-material/Folder';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { OPERATION, PROJECTNAME, SUBSETTING, } from '../../../types/searchTypes';
import { onlyRookNodesSelected } from '../Header/NodeSelection';
import { CustomizedTooltip } from '../../GenericUI/CustomizedTooltip';
export const PROJECTFACET = 'project';
const classes = {
    facetSelectorFooter: {
        gridArea: 'facetSelectorFooter',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '5px 15px',
        zIndex: 200,
        boxShadow: '0px -1px 2px -1px rgba(0, 0, 0, 0.2),0px -1px 3px 0px rgba(0, 0, 0, 0.14), 0px -1px 5px 0px rgba(0, 0, 0, 0.12)',
    },
    button: {
        marginLeft: '10px',
    },
    buttonDiv: {
        display: 'inline-block',
    },
};
export const SearchFooter = ({ user, setResultsWindow, project, selectedNodes, searchQuery, }) => {
    // Lock buttons if no facets are selected:
    const [buttonLocked, lockButtonNoFacet] = React.useState(true);
    useEffect(() => {
        lockButtonNoFacet(!(searchQuery.selectedItems.filter((facet) => facet.facetId !== PROJECTFACET).length > 0));
    }, [searchQuery.selectedItems]);
    /* CMIP 5 datasets contain a variable array, if multiple variable facets are selected,
    it becomes impossible to determine which one to send along in the request - lock button: */
    const [rookLocked, lockRookCMIP5] = React.useState(false);
    useEffect(() => {
        const variableFacetCount = searchQuery.selectedItems.filter((facet) => facet.facetId === 'variable')
            .length || 0;
        if (project.title === PROJECTNAME.CMIP5 && variableFacetCount > 1) {
            lockRookCMIP5(true);
        }
        else {
            lockRookCMIP5(false);
        }
    }, [searchQuery.selectedItems, project.title]);
    return (React.createElement("div", { style: classes.facetSelectorFooter },
        React.createElement("div", { style: { minWidth: 300 } }),
        React.createElement("div", null,
            user && user.notebookId ? (React.createElement(Button, { color: 'primary', startIcon: React.createElement(OpenInBrowserIcon, null), onClick: () => {
                    window.open(user.notebookURL, '_blank');
                } }, "Open your notebook")) : (React.createElement(Button, { disabled: true, color: 'primary', startIcon: React.createElement(OpenInBrowserIcon, null) }, "Open your notebook")),
            React.createElement(Button, { color: 'primary', startIcon: React.createElement(FolderOpenIcon, null), style: {
                    marginRight: 10,
                }, onClick: () => {
                    window.open('https://gitlab.com/is-enes-cdi-c4i/notebooks', '_blank');
                } }, "Scientific Presets")),
        React.createElement("div", { style: {
                marginRight: 10,
                minWidth: 300,
            } },
            onlyRookNodesSelected(selectedNodes) ? (React.createElement(CustomizedTooltip, { title: 'Using Rook WPS subsetting. For CMIP5 only one "variable" facet may be selected.', placement: 'top' },
                React.createElement(Button, { id: 'ROOKWPS_Subsetting', variant: 'contained', color: 'primary', disabled: !user || !user.registered || rookLocked || buttonLocked, sx: classes.button, startIcon: React.createElement(AccountTreeIcon, null), onClick: () => {
                        setResultsWindow({
                            open: true,
                            operation: OPERATION.SUBSETTING,
                            subsettingMode: SUBSETTING.ROOK,
                        });
                    } }, "Subsetting"))) : (React.createElement(CustomizedTooltip, { title: 'No subsetting possible with current node selection. Change node selection to enable subsetting.', placement: 'top' },
                React.createElement("div", { style: classes.buttonDiv },
                    React.createElement(Button, { id: 'OPENDAP_Subsetting', variant: 'contained', color: 'primary', disabled: !user || !user.registered || buttonLocked || true, sx: classes.button, startIcon: React.createElement(AccountTreeIcon, null), onClick: () => {
                            setResultsWindow({
                                open: true,
                                operation: OPERATION.SUBSETTING,
                                subsettingMode: SUBSETTING.OPENDAP,
                            });
                        } }, "Subsetting")))),
            React.createElement(Button, { variant: 'contained', color: 'primary', disabled: buttonLocked, sx: classes.button, startIcon: React.createElement(FolderIcon, null), onClick: () => {
                    setResultsWindow({
                        open: true,
                        operation: OPERATION.DOWNLOAD,
                        subsettingMode: SUBSETTING.NONE,
                    });
                } }, "Download"))));
};
